export default __webpack_public_path__ + "static/media/AdPirates_01.87223642.png";